import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"nw-page-content\" ...attributes>\n  {{yield}}\n</div>")